<template>

    <crud-container :name="name">
        <modal name="approve">
            <h1>Are you sure you want to approve this timesheet?</h1>
            <p>Approving this timesheet is irreversible. Do you want to proceed?</p>
            <textarea placeholder="Any extra information." v-model="status_note"></textarea>
            <div class="actions">
                <a href="#" @click.prevent="closeModal()">Cancel</a>
                <a href="#" class="success" @click.prevent="approveSheet(current_item)">Approve</a>
            </div>
        </modal>
        <modal name="dispute">
            <h1>Are you sure you want to dispute this timesheet?</h1>
            <p>Add a note below to explain why this has been disputed. Do you want to proceed?</p>
            <textarea placeholder="Reasons for dispute." v-model="status_note"></textarea>
            <div class="actions">
                <a href="#" @click.prevent="closeModal()">Cancel</a>
                <a href="#" class="warning" @click.prevent="disputeSheet(current_item)">Dispute</a>
            </div>
        </modal>
        <crud-nav>
            <crud-nav-header title="Timesheets To Approve" disable-create="true"></crud-nav-header>

            <crud-nav-scroll>

                <h3 v-if="submitted_items.length">Submitted</h3>
                <ul v-if="submitted_items.length">
                    <li v-for="sheet in submitted_items">
                        <a href="#" @click.prevent="viewItem(sheet)"><strong>{{ sheet.person }}:</strong> Week
                            {{ sheet.week }} ({{ sheet.total_hours }} Hours)</a>
                    </li>
                </ul>

                <h3 v-if="approved_items.length">Approved</h3>
                <ul v-if="approved_items.length">
                    <li v-for="sheet in approved_items">
                        <a href="#" @click.prevent="viewItem(sheet)"><strong>{{ sheet.person }}:</strong> Week
                            {{ sheet.week }} ({{ sheet.total_hours }} Hours)</a>
                    </li>
                </ul>

                <h3 v-if="disputed_items.length">Disputed</h3>
                <ul v-if="disputed_items.length">
                    <li v-for="sheet in disputed_items">
                        <a href="#" @click.prevent="viewItem(sheet)"><strong>{{ sheet.person }}:</strong> Week
                            {{ sheet.week }} ({{ sheet.total_hours }} Hours)</a>
                    </li>
                </ul>

            </crud-nav-scroll>
        </crud-nav>

        <crud-main>
            <crud-new>

            </crud-new>
            <crud-view>
                <div v-if="viewing_current_item">
                    <crud-main-header
                            :title="'View Hours For Week '+current_item.week+' <small>('+current_item_date_range+')</small>'"
                            can-go-back-to-nav="true"></crud-main-header>
                    <crud-main-scroll>
                        <timesheet-view :sheet="current_item"></timesheet-view>

                        <div class="action-button-group">
                            <a href="#" class="action-button action-button-dismiss"
                               @click.prevent="openModal('dispute')" v-if="current_item.status == 'submitted'">
                                <i class="fa fa-times" aria-hidden="true"></i> Dispute
                            </a>
                            <a href="#" class="action-button action-button-success"
                               @click.prevent="openModal('approve')" v-if="current_item.status != 'approved'">
                                <i class="fa fa-check" aria-hidden="true"></i> Approve
                            </a>
                        </div>
                    </crud-main-scroll>
                </div>
            </crud-view>
        </crud-main>

    </crud-container>
</template>

<script>
    export default {
        data() {
            return {
                name: 'timesheetsToApprove',
                items: [],
                current_item: {},
                status_note: ''
            }
        },
        filters: {},
        watch: {},
        computed: {
            disputed_items: function () {
                return _.filter(this.items, function (item) {
                    return item.status === 'disputed';
                });
            },
            requires_attention_items: function () {
                return _.filter(this.items, function (item) {
                    return item.status === 'requires_attention';
                });
            },
            submitted_items: function () {
                return _.filter(this.items, function (item) {
                    return item.status === 'submitted';
                });
            },
            approved_items: function () {
                return _.filter(this.items, function (item) {
                    return item.status === 'approved';
                });
            },
            requires_attention: function () {
                return !_.isEmpty(this.required_dates);
            },
            viewing_current_item: function () {
                return !_.isEmpty(this.current_item);
            },
            current_item_date_range: function () {
                // This will fuck shit up if we don't have exactly 7 days in the array.
                if (this.current_item.entries.length) {
                    return this.current_item.entries[0].date + ' - ' + this.current_item.entries[this.current_item.entries.length - 1].date;
                }

                return 'No Date Range...';
            }
        },
        methods: {
            openModal(key) {
                if (key) {
                    key = '-' + key;
                }
                this.status_note = '';
                window.eventBus.$emit('modal-open' + key);
            },
            closeModal() {
                this.status_note = '';
                window.eventBus.$emit('modal-close-approve');
                window.eventBus.$emit('modal-close-dispute');
            },
            disputeSheet(sheet) {
                var that = this;
                var sheet = $.extend({}, sheet);
                var url = appUrls.timesheets.dispute.replace('REPLACEME', sheet.id);

                var data = {status_note: this.status_note};

                axios.request({
                    method: 'PUT',
                    url: url,
                    data: data
                }).then(function (response) {

                    that.viewItem(Object.create(Timesheet).fromExisting(response.data.data));
                    that.getItems(true);
                });
                this.closeModal();
            },
            approveSheet(sheet) {
                var that = this;
                var sheet = $.extend({}, sheet);
                var url = appUrls.timesheets.approve.replace('REPLACEME', sheet.id);

                var data = {status_note: this.status_note};

                axios.request({
                    method: 'PUT',
                    url: url,
                    data: data
                }).then(function (response) {

                    that.viewItem(Object.create(Timesheet).fromExisting(response.data.data));
                    that.getItems(true);
                });
                this.closeModal();
            },
            // The Big Daddy Of Methods - Retrieves all methods.
            getItems(dontSelect) {
                var that = this;
                var url = appUrls.timesheets.to_approve;
                var params = {};

                if (this.has_query) {
                    params.query = this.search_query;
                }

                this.items = [];

                axios.get(url, {params: params})
                    .then(function (response) {
                        _.forEach(response.data.data, function (sheet) {
                            that.items.push(Object.create(Timesheet).fromExisting(sheet));
                        });
                        if (!dontSelect && that.submitted_items.length) {
                            that.viewItem(that.submitted_items[0]);
                        }
                    });
            },
            newItem(item) {
                window.eventBus.$emit('crud-show-new-' + this.name);
                window.eventBus.$emit('crud-new-item-' + this.name, item);
            },
            viewItem(item) {
                window.eventBus.$emit('crud-view-item-' + this.name, item);
            },
            backToNav: function () {
                window.eventBus.$emit('crud-back-to-nav-' + this.name);
            },
            backToItem: function () {
                window.eventBus.$emit('crud-back-' + this.name);
            }
        },
        mounted() {
            var that = this;

            this.getItems();

            window.eventBus.$on('crud-new-item-' + this.name, function (item) {
                that.current_item = {};
            });

            window.eventBus.$on('crud-view-item-' + this.name, function (item) {
                that.current_item = $.extend({}, item);
            });

            window.eventBus.$on('crud-back-' + this.name, function (item) {
                that.viewItem(item);
            });

            window.eventBus.$on('crud-back-to-nav-' + this.name, function () {
                that.current_item = {};
            });
        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';

    dl dd {
        width: 350px;
        max-width: 100%;
    }
</style>